export default __webpack_public_path__ + "static/media/tmp_user_image.b06453d8.png";